import { useAalKpisQuery } from "../aalV2";

export type SuspensionsAALKPIsFilters = {
  start_date: string;
  end_date: string;
};

export type SuspensionsAALKPIsResponse = {
  users_suspended_delta: number;
  users_suspended_pct_change: number;
  users_unsuspended_delta: number;
  users_unsuspended_pct_change: number;
  comparison_start_date: string;
  comparison_end_date: string;
} | null;

export const useGetAALSuspensionsKPIs = (
  filters: SuspensionsAALKPIsFilters,
) => {
  const { start_date, end_date } = filters;

  return useAalKpisQuery<SuspensionsAALKPIsResponse>("suspensions", {
    start_date,
    end_date,
  });
};
